"use client";
import styles from './styles.module.scss';
import { useState, useContext } from 'react';
import { NavigationContext } from "@/providers/navigationProvider";
import { useRouter } from 'next/navigation';
const Search = () => {
    const context = useContext(NavigationContext);
    const {setOpen} = context || {}
    const [query, setQuery] = useState('');
    const router = useRouter();

    const handleSearch = (e) => {
        e.preventDefault();
        setOpen(false);
        router.push(`/search?search=${encodeURIComponent(query)}`);
    };

    return (
        <section className={styles.searchBar}>
            <div className={styles.searchBar__inner}>
                <p className={styles.searchBar__headline}>
                    Search Resources
                </p>
                <form onSubmit={handleSearch} className={`${styles.searchBar__form}`}>
                    <input onChange={(e) => setQuery(e?.target?.value)} placeholder='Search...' className={`${styles.searchBar__input} input`} type="text"/>
                    <button type={'submit'} className={`primary-fill large button ${styles.searchBar__cta}  `}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M14.76 13.27L20.49 19L19 20.49L13.27 14.76C12.2 15.53 10.91 16 9.5 16C5.91 16 3 13.09 3 9.5C3 5.91 5.91 3 9.5 3C13.09 3 16 5.91 16 9.5C16 10.91 15.53 12.2 14.76 13.27ZM9.5 5C7.01 5 5 7.01 5 9.5C5 11.99 7.01 14 9.5 14C11.99 14 14 11.99 14 9.5C14 7.01 11.99 5 9.5 5Z" fill="#FEF1F7"/>
                        </svg>

                    </button>
                </form>
            </div>
        </section>
    );
}
export default Search;